// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title_wrapper[data-v-1e3eba4e] {\n  padding-left: 8px;\n  border-left: 2px solid #077cac;\n}\n.title_wrapper .title[data-v-1e3eba4e] {\n  font-size: 18px;\n  font-weight: bold;\n  color: #434355;\n  line-height: 1;\n  padding-bottom: 2px;\n}\n.title_wrapper .sub-title[data-v-1e3eba4e] {\n  font-size: 12px;\n  font-weight: bold;\n  color: #878799;\n  line-height: 1;\n}\n", ""]);
// Exports
module.exports = exports;
